import { createSelector } from 'reselect'

import { getAuth } from '../root.selectors'
import { getPersistedSession } from '../persist/persist.selectors'

export const getAuthSession = (state) => getAuth(state).session
export const isSTKExpired = (state) => getAuthSession(state).isSTKExpired
export const getToken = (state) => getAuthSession(state).token

export const getSession = createSelector([getAuthSession, getPersistedSession], (auth, persisted) => ({
  ...auth,
  ...persisted,
  isAuthed: Boolean(auth.token),
  captcha: auth.captcha,
}))
